<template>
  <div class="oee-container" ref="kanban">

    <div style="padding-top: 10px;padding-bottom: 10px;">
      <img class="oee-bg-img-top" :src="require('../../assets/oee-4.png')" />
      <div style="position: absolute;color:white;top:6%;left:30%;font-size:32px;font-weight: bold;width:38%;">
        《{{ companyName }}》生产管控中心
      </div>
    </div>

    <div style="display: flex;">
      <div style="width:32%;margin-left: 1.5%;border:1px solid;border-image: linear-gradient(blue,white)30 30;">

        <div style="position:relative;width:100%;height:280px;font-size:38px;">
          <div style="position: absolute;top:95%;left:9%;color:yellow;width:35%;">
            <div style="font-size:18px;">设备总数</div>
            <div style="width:40%;margin:5% 0 0 30%;background-color: blue;border-radius: 5px;text-align: center;">
              {{ totalEquip }}
            </div>
          </div>

          <img class="oee-bg-img-zero" :src="require('../../assets/oee-3.png')" />
          <div style="position: absolute;top:48%;left:12%;font-size:13px;color:yellow;width:28%;">
            <span style="font-size:40px;">{{ todayPwOnRate }}%</span>
            <br />今日开机率
          </div>

          <!-- <img class="oee-bg-img-one" :src="empOEEPath1" /> -->
          <div style="position: absolute;color:white;top:34%;left:75%;font-size:18px;">
            在产机台
          </div>
          <div
            style="position: absolute;color:yellow;top:28.5%;left:57%;width:15%;background-color: green;border-radius: 5px;">
            {{ producingNum }}
          </div>

          <!-- <img class="oee-bg-img-two" :src="require('../../assets/oee-2.png')" /> -->
          <div style="position: absolute;color:white;top:55%;left:75%;font-size:18px;">
            待产机台
          </div>
          <div
            style="position: absolute;color:blue;top:50%;left:57%;width:15%;background-color: orange;border-radius: 5px;">
            {{ waitEquipCount }}
          </div>

          <div style="position: absolute;color:white;top:75%;left:75%;font-size:18px;">
            检修机台
          </div>
          <div
            style="position: absolute;color:black;top:70%;left:57%;width:15%;background-color: skyblue;border-radius: 5px;">
            {{ badEquipCount }}
          </div>

          <div style="position: absolute;color:white;top:95%;left:75%;font-size:18px;">
            暂停机台
          </div>
          <div
            style="position: absolute;color:black;top:90%;left:57%;width:15%;background-color: red;border-radius: 5px;">
            {{ pauseEquipCount }}
          </div>

          <div style="position: absolute;color:white;top:115%;left:75%;font-size:18px;">
            试模机台
          </div>
          <div
            style="position: absolute;color:black;top:110%;left:57%;width:15%;background-color: yellow;border-radius: 5px;">
            {{ testEquipCount }}
          </div>

          <div style="width:100%;height:270px;font-size:36px;color:yellow;padding:20px 0;">
            ···《订单机台管理》···
          </div>
        </div>

        <div style="height: 50px;padding:20px 0;border-bottom:3px dotted yellow;">

        </div>

        <!-- <div id="equipChart"></div> -->
        <div style="display:flex;">
          <div style="width: 50%;font-size:18px;color:yellow;text-align: left;">
            <div style="display:flex;">
              <div style="padding:13px 10px;">在产订单数 </div>
              <div
                style="width:35%;background-color: blue;padding:3px 5px;border-radius: 5px;margin: 5px 0;text-align: center;font-size:24px;">
                {{ producingOrderCount }}</div>
            </div>

            <div style="display:flex;">
              <div style="padding:13px 10px;">待产订单数 </div>
              <div
                style="width:35%;background-color: blue;padding:3px 5px;border-radius: 5px;margin: 5px 0;text-align: center;font-size:24px;">
                {{ waitOrderCount }}</div>
            </div>

            <div style="display:flex;">
              <div style="padding:13px 10px;">待产总工时 </div>
              <div
                style="width:35%;background-color: blue;padding:3px 5px;border-radius: 5px;margin: 5px 0;text-align: center;font-size:24px;">
                {{ waitTotalWorkHour }}</div>
            </div>

            <div style="display:flex;">
              <div style="padding:13px 10px;">待产总数量 </div>
              <div
                style="width:35%;background-color: blue;padding:3px 5px;border-radius: 5px;margin: 5px 0;text-align: center;font-size:20px;">
                {{ waitTotalCount }}</div>
            </div>

            <div style="display:flex;">
              <div style="padding:13px 10px;">超时订单数 </div>
              <div
                style="width:35%;background-color: blue;padding:3px 5px;border-radius: 5px;margin: 5px 0;text-align: center;font-size:24px;">
                {{ timeoutOrderCount }}</div>
            </div>

            <div style="display:flex;">
              <div style="padding:13px 10px;">准时订单数 </div>
              <div
                style="width:35%;background-color: blue;padding:3px 5px;border-radius: 5px;margin: 5px 0;text-align: center;font-size:24px;">
                {{ onTimeOrderCount }}</div>
            </div>
          </div>

          <table class="oee-table-0" style="width: 50%;">
            <tr>
              <td style="width: 10px; max-width: 10px">代号</td>
              <td style="width: 15px; max-width: 15px">订单</td>
              <td style="width: 20px; max-width: 20px">数量</td>
            </tr>
            <tr v-for="(item, index) in orderInfoList" :key="index">
              <td>{{ item.salesman }}</td>
              <td>{{ item.totalOrder }}</td>
              <td>{{ item.totalCount }}</td>
            </tr>
          </table>

        </div>

      </div>

      <div style="width:32%;border-top:1px solid blue;border-bottom:1px solid white;">

        <div style="position:relative;width:100%;height:280px;font-size:38px;">

          <img class="oee-bg-img-zero" :src="require('../../assets/oee-3.png')" />

          <div style="position: absolute;top:48%;left:12%;font-size:13px;color:yellow;width:28%;">
            <span style="font-size:40px;">{{ todayPatrolRate }}%</span>
            <br />今日合格率
          </div>

          <!-- <img class="oee-bg-img-one" :src="empOEEPath1" /> -->
          <div style="position: absolute;color:white;top:34%;left:75%;font-size:18px;">
            今日巡检
          </div>
          <div
            style="position: absolute;color:yellow;top:28.5%;left:57%;width:15%;background-color: green;border-radius: 5px;">
            {{ todayPatrolCount }}
          </div>

          <!-- <img class="oee-bg-img-two" :src="require('../../assets/oee-2.png')" /> -->
          <div style="position: absolute;color:white;top:55%;left:75%;font-size:18px;">
            巡检正常
          </div>
          <div
            style="position: absolute;color:blue;top:50%;left:57%;width:15%;background-color: orange;border-radius: 5px;">
            {{ todayPatrolCount - todayAbnormalCount }}
          </div>

          <!-- <img class="oee-bg-img-three" :src="require('../../assets/oee-2.png')" /> -->
          <div style="position: absolute;color:white;top:75%;left:75%;font-size:18px;">
            巡检异常
          </div>
          <div
            style="position: absolute;color:black;top:70%;left:57%;width:15%;background-color: red;border-radius: 5px;">
            {{ todayAbnormalCount }}
          </div>

          <div style="width:100%;height:270px;font-size:36px;color:yellow;padding:20px 0;">
            ···《品质管理》···
          </div>

        </div>

        <div style="height: 50px;padding:20px 0;border-bottom:3px dotted yellow;">

        </div>

        <!-- <div id="qualityChart"></div> -->
        <div style="color:yellow;font-size:large;padding: 10px;">~ 异常展现 ~</div>
        <table class="oee-table" style="width: 100%;">
          <tr>
            <td style="width: 20px; max-width: 20px">机台号</td>
            <td style="width: 30px; max-width: 30px">问题展现</td>
            <td style="width: 20px; max-width: 20px">发现人</td>
          </tr>
          <tr v-for="(item, index) in patrolRecordList" :key="index">
            <td>{{ item.patrolPointName }}</td>
            <td>{{ item.remark }}</td>
            <td>{{ item.maker }}</td>
          </tr>
        </table>
      </div>

      <div style="width:32%;margin-right: 10px;border:1px solid;border-image: linear-gradient(blue,white)30 30;">

        <div style="position:relative;width:100%;height:280px;font-size:38px;">
          <img class="oee-bg-img-zero" :src="require('../../assets/oee-3.png')" />
          <div style="position: absolute;color:white;top:50%;left:12%;font-size:13px;color:yellow;width:28%;">
            <span style="font-size:36px;">{{ inventoryTotal }}</span>
            <br />库存总数
          </div>

          <div style="position: absolute;color:white;top:34%;left:75%;font-size:18px;">
            入库单数
          </div>
          <div
            style="position: absolute;color:yellow;top:28.5%;left:57%;width:15%;background-color: green;border-radius: 5px;">
            {{ inStockCount }}
          </div>

          <!-- <img class="oee-bg-img-two" :src="require('../../assets/oee-2.png')" /> -->
          <div style="position: absolute;color:white;top:55%;left:75%;font-size:18px;">
            入库总数
          </div>
          <div
            style="position: absolute;color:blue;top:50%;right:28%;min-width:15%;background-color: orange;border-radius: 5px;">
            {{ inStockTotal }}
          </div>

          <div style="position: absolute;color:white;top:75%;left:75%;font-size:18px;">
            出库单数
          </div>
          <div
            style="position: absolute;color:black;top:70%;left:57%;width:15%;background-color: skyblue;border-radius: 5px;">
            {{ outStockCount }}
          </div>

          <div style="position: absolute;color:white;top:95%;left:75%;font-size:18px;">
            出库总数
          </div>
          <div
            style="position: absolute;color:black;top:90%;right:28%;min-width:15%;background-color: red;border-radius: 5px;">
            {{ outStockTotal }}
          </div>

          <div style="width:100%;height:290px;font-size:36px;color:yellow;padding:20px 0;">
            ···《仓库管理》···
          </div>
        </div>

        <div style="height: 40px;padding:25px 0;border-bottom:3px dotted yellow;">

        </div>

        <!-- <div id="empChart"></div> -->
        <div style="color:yellow;font-size:large;padding: 10px;">~ 调机榜 ~</div>
        <table class="oee-table-0" style="width: 100%;">
          <tr>
            <td style="width: 20px; max-width: 20px">代号</td>
            <td style="width: 20px; max-width: 20px">日/上机</td>
            <td style="width: 20px; max-width: 20px">月/上机</td>
            <td style="width: 20px; max-width: 20px">月/产中停</td>
          </tr>

          <tr v-for="(item, index) in operateTimesList" :key="index">
            <td>{{ item.maker }}</td>
            <td>{{ item.total }}</td>
            <td>{{ item.monthTotal }}</td>

            <td>{{ toFloat3(item.stopMonthTotal / item.monthTotal) }}%</td>
          </tr>
        </table>
      </div>
    </div>

    <div style="position: absolute;right: 7px;bottom: 5px;">
      <i class="el-icon-full-screen" @click="fullScreen" style="color:orange"></i>
    </div>
  </div>
</template>

<script>
// import echarts from 'echarts'
export default {
  data() {
    return {
      token: this.getToken(),
      companyId: this.getCompanyId(),
      companyName: "中国制造",

      patrolRecordList: [],
      orderInfoList: [],
      operateTimesList: [],

      oeeList: [],

      empOEEPath1: require("../../assets/oee-2.png"),

      // attendanceNum: 0,
      attendenceRequired: 0,
      todayAbsence: 0,

      totalEquip: 0,
      producingNum: 0,
      waitEquipCount: 0,
      badEquipCount: 0,
      pauseEquipCount: 0,
      testEquipCount: 0,

      producingOrderCount: 0,
      waitOrderCount: 0,
      waitTotalWorkHour: 0,
      waitTotalCount: 0,
      timeoutOrderCount: 0,
      onTimeOrderCount: 0,

      inStockCount: 0,
      outStockCount: 0,

      inStockTotal: 0,
      outStockTotal: 0,

      inventoryTotal: 0,

      todayPwOnRate: 0,

      // passRate: 0,

      todayPatrolCount: 0,
      todayAbnormalCount: 0,
      todayPatrolRate: 0,

      timer: '',

      // 实时数据数组
      monthDay: ["1日", "5日", "10日", "15日", "20日", "25日", "30日"],
      attendanceRate: [1.0, 2.0, 3.0],
      powerOnRate: [10.1, 11.2, 12.3],

      see: [5.6, 6.7, 7.8],

      echartsOption: {
        legend: {
          textStyle: {
            color: "#ffffff",
            fontSize: 15,
          },
          data: ["员工出勤率"],
        },
        xAxis: {
          nameTextStyle: {
            color: "#ffffff",
            fontWeight: 100,
            fontSize: 18,
          },
          axisLine: {
            show: false,
          },
          type: "category",
          boundaryGap: false,
          data: ["1日", "5日", "10日", "15日", "20日", "25日", "30日"],
        },
        yAxis: {
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 18,
          },
          type: "value",
          scale: true,
          axisLabel: {
            color: "#ffffff",
            interval: "auto",
            formatter: "{value}%",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            name: "员工出勤率",
            type: "line",
            data: [90, 95, 94, 92, 95, 93, 98], // 绑定实时数据数组
            areaStyle: {
              opacity: 0.8,
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(128, 255, 165)",
                },
                {
                  offset: 1,
                  color: "rgb(1, 191, 236)",
                },
              ]),
            },
          },
        ],
      },
      echartsOption2: {
        legend: {
          textStyle: {
            color: "#ffffff",
            fontSize: 15,
          },
          data: ["开机率"],
        },
        xAxis: {
          nameTextStyle: {
            color: "#ffffff",
            fontWeight: 600,
            fontSize: 18,
          },
          type: "category",
          boundaryGap: false,
          data: ["1日", "5日", "10日", "15日", "20日", "25日", "30日"],
        },
        yAxis: {
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 18,
          },
          type: "value",
          scale: true,
          axisLabel: {
            color: "#ffffff",
            interval: "auto",
            formatter: "{value}%",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            name: "开机率",
            type: "line",
            data: [80, 90, 88, 92, 89, 90, 91], // 绑定实时数据数组
            areaStyle: {
              opacity: 0.8,
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(55, 162, 255)",
                },
                {
                  offset: 1,
                  color: "rgb(116, 21, 219)",
                },
              ]),
            },
          },
        ],
      },
      echartsOption3: {
        legend: {
          textStyle: {
            color: "#ffffff",
            fontSize: 15,
          },
          data: ["产品合格率"],
        },
        xAxis: {
          nameTextStyle: {
            color: "#ffffff",
            fontWeight: 600,
            fontSize: 18,
          },
          type: "category",
          boundaryGap: false,
          data: ["1日", "5日", "10日", "15日", "20日", "25日", "30日"],
        },
        yAxis: {
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 18,
          },
          type: "value",
          scale: true,
          axisLabel: {
            color: "#ffffff",
            interval: "auto",
            formatter: "{value}%",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            name: "产品合格率",
            type: "line",
            data: [81, 85, 90, 79, 83, 91, 77], // 绑定实时数据数组
            areaStyle: {
              opacity: 0.8,
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(255, 191, 0)",
                },
                {
                  offset: 1,
                  color: "rgb(224, 62, 76)",
                },
              ]),
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.setDefaultPath('/oEE')

    this.$axios({
      method: "post",
      url: "/shiro/company/get",
      data: {
        id: this.companyId,
      },
      headers: {
        token: this.token,
      },
    }).then((result) => {
      this.companyName = result.data.data.companyName
    })

    this.getAll()

    this.timer = setInterval(this.getAll, 300000)

  },
  updated() {
    // console.log("updated")
  },
  methods: {
    toFloat3(val) {

      if (isNaN(val)) {
        val = 0
      }

      return parseFloat((val.toFixed(3) * 100).toFixed(10))
    },
    getOperateInfo() {
      this.$axios({
        method: "post",
        url: "/shiro/operate/record/times",
        data: {
          companyId: this.companyId
        },
        headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        if (data.status != 200) {
          this.$message({
            type: 'info',
            message: data.msg
          })
          return
        }

        this.operateTimesList = data.data

      })
    },
    getOrderWaiteInfo() {
      this.$axios({
        method: "post",
        url: "/shiro/plastic/order/total/wait",
        data: {
          companyId: this.companyId
        },
        headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        if (data.status != 200) {
          this.$message({
            type: 'info',
            message: data.msg
          })
          return
        }

        this.orderInfoList = data.data
        var totalCount = 0

        for (let i in this.orderInfoList) {
          totalCount += this.orderInfoList[i].totalCount
        }

        this.waitTotalCount = totalCount

      })
    },
    getAllPatrolRecord() {

      this.$axios({
        method: "post",
        url: "/shiro/patrol/record/getAll",
        data: {
          status: 0,
          startTime: null,
          endTime: null,
          maker: null,
          patrolPointId: null,
          pageIndex: 0,
          pageNum: 5,
          companyId: this.companyId
        },
        headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        if (data.status != 200) {
          this.$message({
            type: 'info',
            message: data.msg
          })
          return
        }

        this.patrolRecordList = data.data
        this.total = this.patrolRecordList[0].total

      })
    },
    getAll() {
      this.$axios({
        method: "post",
        url: "/shiro/oee/getAll",
        data: {
          companyId: this.companyId,
        },
        headers: {
          token: this.token,
        },
      }).then((result) => {
        const data = result.data

        if (data.status === 400) {
          clearInterval(this.timer)
          this.$router.push({ path: "/Login" })
        }

        if (data.status === 202) {
          this.$notify({
            title: "重要提示",
            message: data.msg,
            duration: 0,
          })
          return
        }

        this.oeeList = data.data

        this.todayPatrolCount = this.oeeList[0].todayPatrolCount
        this.todayAbnormalCount = this.oeeList[0].todayAbnormalCount
        this.todayPatrolRate = this.toInt(
          1 - this.todayAbnormalCount / this.todayPatrolCount
        )

        this.waitEquipCount = this.oeeList[0].waitEquipCount
        this.badEquipCount = this.oeeList[0].badEquipCount
        this.pauseEquipCount = this.oeeList[0].pauseEquipCount
        this.testEquipCount = this.oeeList[0].testEquipCount

        this.producingOrderCount = this.oeeList[0].producingOrderCount
        this.waitOrderCount = this.oeeList[0].waitOrderCount
        this.timeoutOrderCount = this.oeeList[0].timeoutOrderCount
        this.onTimeOrderCount = this.oeeList[0].onTimeOrderCount

        this.waitTotalWorkHour = this.oeeList[0].waitTotalWorkHour

        this.inStockCount = this.oeeList[0].inStockCount
        this.outStockCount = this.oeeList[0].outStockCount

        this.inStockTotal = this.oeeList[0].inStockTotal
        this.outStockTotal = this.oeeList[0].outStockTotal

        this.inventoryTotal = this.oeeList[0].inventoryTotal

        // this.attendanceNum = this.oeeList[0].attendance
        this.attendenceRequired = this.oeeList[0].requiredAttendance + 100
        // this.todayAbsence = this.attendenceRequired - this.attendanceNum

        var date = new Date()
        var dateNum = date.getDate()

        this.monthDay = []
        this.attendanceRate = []
        this.powerOnRate = []
        for (let i in this.oeeList) {
          this.monthDay.push(this.oeeList[i].monthDay)

          this.attendanceRate.push(
            this.toInt(
              this.oeeList[i].attendance / this.oeeList[i].requiredAttendance
            )
          )

          this.powerOnRate.push(
            this.toInt(this.oeeList[i].equipInProd / this.oeeList[i].totalEquip)
          )

          if (i == dateNum - 1) {

            this.totalEquip = this.oeeList[i].totalEquip
            this.producingNum = this.oeeList[i].equipInProd

            this.todayPwOnRate = this.toInt(
              this.oeeList[i].equipInProd / this.oeeList[i].totalEquip
            )
          }
        }

        this.getAllPatrolRecord()

        this.getOrderWaiteInfo()

        this.getOperateInfo()

        this.echartsOption.series[0].data = this.attendanceRate;
        this.echartsOption.xAxis.data = this.monthDay;
        this.empChart.setOption(this.echartsOption);

        this.echartsOption2.series[0].data = this.powerOnRate;
        this.echartsOption2.xAxis.data = this.monthDay;
        this.equipChart.setOption(this.echartsOption2);
      })
    },
    toInt(val) {
      if (isNaN(val)) {
        val = 0
      }

      return parseInt(val.toFixed(2) * 100)
    },
    fullScreen() {
      let element = this.$refs.kanban;

      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen
    }
  }
}
</script>

<style>
.oee-container {
  width: 100%;
  height: 860px;
  background-color: #06207d;
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  position: relative;
}

.oee-bg-img-top {
  width: 90%;
  height: 130px;
}

.oee-bg-img-zero-0 {
  position: absolute;
  top: 57%;
  left: 8%;
  width: 41%;
  height: 160px;
}

.oee-bg-img-zero {
  position: absolute;
  top: 32%;
  left: 5%;
  width: 41%;
  height: 160px;
}

.oee-bg-img-one {
  position: absolute;
  top: -38%;
  left: 35%;
  width: 100%;
  height: 90%;
}

.oee-bg-img-two {
  position: absolute;
  top: -10%;
  left: 35%;
  width: 100%;
  height: 90%;
}

.oee-bg-img-three {
  position: absolute;
  top: 18%;
  left: 35%;
  width: 100%;
  height: 90%;
}

.oee-bg-img-four {
  position: absolute;
  top: 46%;
  left: 35%;
  width: 100%;
  height: 90%;
}

div::-webkit-scrollbar {
  background: #6f5499;
  border-radius: 10px;
  width: 10px;
  height: 10px;
}

div::-webkit-scrollbar-thumb {
  background: orange;
  border-radius: 10px;
}

.el-pagination__total {
  color: green;
}

#empChart {
  width: 100%;
  height: 300px;
  margin: 20px 20px 0px 20px;
  color: white;
}

#equipChart {
  width: 100%;
  height: 300px;
  margin: 20px 20px 0px 20px;
  color: white;
}

#qualityChart {
  width: 100%;
  height: 300px;
  margin: 20px 20px 0px 20px;
  color: white;
}

.oee-table,
.oee-table-0 {
  table-layout: fixed;
  border: 1px solid #e5e7eb;
  font-size: 15px;
  font-weight: bold;
  color: white;
  border-collapse: collapse;
}

.oee-table td {
  border: 1px solid blue;
  padding: 7px 0;
}

.oee-table-0 td {
  border: 1px solid blue;
  padding: 1px 0;
}
</style>